import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import imageIcon from "../../Assets/images/VoxApp-Icon.png";
import CountryPhoneInput from "../../Common/CountryPhoneInput";
import { Loader } from "../../Common/Loader";
import {
  emailValidation,
  getPhoneNumberLimits,
  handlePhoneNoChange,
  nameValidation,
  phoneNumberValidation,
} from "../../Common/Validations";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import { saveCurrentUserData } from "../../Redux/Slice/Common/CurrentUserSlice";
import { setUnsavedChanges } from "../../Redux/Slice/Common/SelectedTabSlice";
import { UpdateCustomer } from "../../Redux/Slice/Customers/UpdateCustomerSlice";
import { uploadCompanyLogo } from "../../Redux/Slice/Customers/UploadCompanyLogoSlice";
import { getUserById } from "../../Redux/Slice/Users/GetUserById";
import { updateUser } from "../../Redux/Slice/Users/UpdateUserSlice";
import { TransactionHistory } from "../TransactionHistory/TransactionHsitory";
import { ChangePassword } from "./ChangePassword";
import CustomerApiKeyPassword from "./CustomerApiKeyPassword";
import PaymentMethod from "./PaymentMethods/PaymentMethod";
import Dropdown from "../../Common/Dropdown";
import { getIndustryList } from "../../Redux/Slice/Common/GetIndustryListSlice";

export const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    countryCallingCode: "+61",
    image: "",
    isMfaEnabled: false,
  });
  const [isDefaultEmail, setIsDefaultEmail] = useState(false);
  const [apiKeyAndPassword, setAPIKeyAndPassword] = useState(null);
  const [companyFormData, setCompanyFormData] = useState({
    companyName: "",
    email: "",
    phoneNumber: "",
    countryCallingCode: "+61",
    industryType: "",
  });
  const [formError, setFormError] = useState({
    firstNameError: "",
    lastNameError: "",
    phoneError: "",
  });
  const [companyFormError, setCompanyFormError] = useState({
    firstNameError: "",
    phoneError: "",
    emailError: "",
    industryTypeError: "",
  });
  const [companyLogo, setCompanyLogo] = useState(null);
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [selectedTab, setSelectedTab] = useState(1);
  const [successMessage, setSuccessMessage] = useState("");
  const [confirmModel, setCOnfirmModel] = useState(false);
  const [confirmMessage, setCOnfirmMessage] = useState(false);
  const [confirmModel2, setCOnfirmModel2] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [imageData, setImageData] = useState();
  const [image, setImage] = useState();
  const { userPlanFeatures } = useSelector((s) => s?.userPlanDetails);
  const industryListData = useSelector(
    (s) => s?.industryList?.industryListData
  );

  const getUserInitials = (name) => {
    const arr = name.split(" ");
    var str = "";
    arr.forEach((x) => (str = str + x[0]));
    return str;
  };

  const updateLocalStorageUserData = (latestUserData) => {
    try {
      let userData2 = JSON.parse(localStorage.getItem("userData"));
      userData2.firstName = latestUserData?.firstName;
      userData2.lastName = latestUserData?.lastName;
      userData2.countryCallingCode = latestUserData?.countryCallingCode;
      userData2.phoneNumber = latestUserData?.phoneNumber;
      userData2.avatar = latestUserData?.avatar;
      userData2.isMfaEnabled = latestUserData?.isMfaEnabled ?? false;
      if (latestUserData?.customer) {
        userData2.customer.companyName = latestUserData?.customer?.companyName;
        userData2.customer.countryCallingCode =
          latestUserData?.customer?.countryCallingCode;
        userData2.customer.phoneNumber = latestUserData?.customer?.phoneNumber;
      }
      localStorage.setItem("userData", JSON.stringify(userData2));
      dispatch(saveCurrentUserData(userData2));
    } catch (error) {}
  };

  const setProfileByLocalStorage = () => {
    if (userData) {
      setFormData({
        firstName: userData.firstName,
        lastName: userData.lastName,
        email: userData.email,
        phoneNumber: userData.phoneNumber,
        countryCallingCode: userData.countryCallingCode,
        image: "",
        isMfaEnabled: userData?.isMfaEnabled ?? false,
      });
      if (userData?.avatar) {
        setImageData(userData?.avatar);
      }
    }
    if (userData.customer) {
      setCompanyFormData({
        companyName: userData.customer.companyName,
        email: userData.customer.email,
        phoneNumber: userData.customer.phoneNumber,
        countryCallingCode: userData.customer.countryCallingCode,
        industryType: userData?.customer?.industryType?.name || "",
      });
      setCompanyLogo(userData?.customer?.logo);
      setAPIKeyAndPassword(userData?.customer?.apiKeyPassword);
      setIsDefaultEmail(userData?.customer?.isDefaultEmail);
    }
  };

  const getUserProfile = async () => {
    try {
      setIsLoading(true);
      const resutOfUserDetails = await dispatch(getUserById(userData?.id));
      if (
        getUserById.fulfilled.match(resutOfUserDetails) &&
        resutOfUserDetails?.payload?.success === true
      ) {
        const currentUserDetails = resutOfUserDetails?.payload?.data;
        if (currentUserDetails) {
          setFormData({
            firstName: currentUserDetails?.firstName,
            lastName: currentUserDetails?.lastName,
            email: currentUserDetails?.email,
            phoneNumber: currentUserDetails?.phoneNumber,
            countryCallingCode: currentUserDetails?.countryCallingCode,
            image: currentUserDetails?.avatar,
            isMfaEnabled: currentUserDetails?.isMfaEnabled,
          });
          if (currentUserDetails?.avatar) {
            setImageData(currentUserDetails?.avatar);
          }
          updateLocalStorageUserData(currentUserDetails);
        }
        if (currentUserDetails?.customer) {
          setCompanyFormData({
            companyName: currentUserDetails?.customer?.companyName,
            email: currentUserDetails?.customer?.email,
            phoneNumber: currentUserDetails?.customer?.phoneNumber,
            countryCallingCode:
              currentUserDetails?.customer?.countryCallingCode,
            industryType:
              currentUserDetails?.customer?.industryType?.name || "",
          });
          setAPIKeyAndPassword(currentUserDetails?.customer?.apiKeyPassword);
          setCompanyLogo(currentUserDetails?.customer?.logo);
          setIsDefaultEmail(currentUserDetails?.customer?.isDefaultEmail);
        }
      } else {
        setProfileByLocalStorage();
      }
    } catch (error) {
      setProfileByLocalStorage();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    dispatch(getIndustryList(userData?.customer?.id));
    getUserProfile();
  }, []);

  const handleChangeImage = (e) => {
    if (e.target.files?.length > 0) {
      setHasChanged(true);
      dispatch(setUnsavedChanges(true));
      setImage(e.target.files[0]);
      setImageData(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleChange = async (e) => {
    let { name, value } = e.target;
    value = value.trimStart();
    await dispatch(setUnsavedChanges(true));
    setHasChanged(true);
    if (name === "firstName") {
      const isValid = nameValidation(value);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, firstNameError: "" });
      } else {
        setFormError({
          ...formError,
          firstNameError: "Please enter valid name",
        });
      }
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      setFormData({ ...formData, [name]: value });
    } else if (name === "lastName") {
      const isValid = nameValidation(value);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, lastNameError: "" });
      } else {
        setFormError({
          ...formError,
          lastNameError: "Please enter valid name",
        });
      }
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      setFormData({ ...formData, [name]: value });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleCountryCodeChange = async (e) => {
    const { name, value } = e.target;
    setHasChanged(true);
    await dispatch(setUnsavedChanges(true));
    let formatted = formData.phoneNumber;
    setFormData({ ...formData, [name]: value, phoneNumber: formatted });
    const minDigits = getPhoneNumberLimits(value)?.min ?? 10;
    const rawDigits = formData.phoneNumber.replace(/\D/g, "");
    const isValid = phoneNumberValidation(rawDigits, value);
    setFormError({
      ...formError,
      phoneError:
        isValid || value === ""
          ? ""
          : rawDigits.length < minDigits
          ? `Phone number must be at least ${minDigits} digits long.`
          : "Please enter a valid phone number",
    });
  };

  const handleChangeMfa = async (checked) => {
    setFormData({ ...formData, isMfaEnabled: checked });
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
  };

  const handlePhoneChange = async (e) => {
    let { name, value } = e.target;
    handlePhoneNoChange(
      e,
      formData.countryCallingCode,
      () => setFormData({ ...formData, [name]: value }),
      (newError) => setFormError({ ...formError, phoneError: newError }),
      (isChanged) => {
        setHasChanged(isChanged);
        dispatch(setUnsavedChanges(true));
      },
      false
    );
  };

  const handleCompanyChange = async (e) => {
    let { name, value } = e.target;
    value = value.trimStart();
    setHasChanged(true);
    if (name === "companyName") {
      const isValid = nameValidation(value);
      if (isValid || value.trim() === "") {
        setCompanyFormError({ ...companyFormError, firstNameError: "" });
      } else {
        setCompanyFormError({
          ...companyFormError,
          firstNameError: "Please enter valid name",
        });
      }
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      setCompanyFormData({ ...companyFormData, [name]: value });
    } else if (name === "email") {
      value = value.trimEnd();
      const isValid = emailValidation(value);
      if (isValid || value === "") {
        setCompanyFormError({ ...companyFormError, emailError: "" });
      } else {
        setCompanyFormError({
          ...companyFormError,
          emailError: "Please enter valid email",
        });
      }
      setCompanyFormData({ ...companyFormData, [name]: value });
    } else {
      setCompanyFormData({ ...companyFormData, [name]: value });
    }
    await dispatch(setUnsavedChanges(true));
  };

  const handleCompanyCountryCodeChange = async (e) => {
    const { name, value } = e.target;
    setHasChanged(true);
    await dispatch(setUnsavedChanges(true));
    let formatted = companyFormData.phoneNumber;
    const minDigits = getPhoneNumberLimits(value)?.min ?? 10;
    const rawDigits = companyFormData?.phoneNumber.replace(/\D/g, "");
    const isValid = phoneNumberValidation(rawDigits, value);
    setCompanyFormData({
      ...companyFormData,
      [name]: value,
      phoneNumber: formatted,
    });
    setCompanyFormError({
      ...companyFormError,
      phoneError:
        isValid || value === ""
          ? ""
          : rawDigits.length < minDigits
          ? `Phone number must be at least ${minDigits} digits long.`
          : "Please enter a valid phone number",
    });
  };

  const handleCompanyPhoneChange = async (e) => {
    // await dispatch(setUnsavedChanges(true));
    let { name, value } = e.target;
    handlePhoneNoChange(
      e,
      companyFormData.countryCallingCode,
      () => setCompanyFormData({ ...companyFormData, [name]: value }),
      (newError) =>
        setCompanyFormError({ ...companyFormError, phoneError: newError }),
      (isChanged) => {
        setHasChanged(isChanged);
        dispatch(setUnsavedChanges(true));
      },
      false
    );
  };

  const handleChangeIndustryType = (selectedOption) => {
    setCompanyFormData((prev) => ({
      ...prev,
      industryType: selectedOption?.label,
    }));
    setHasChanged(true);
    dispatch(setUnsavedChanges(true));
  };

  const formattedIndustryList = useMemo(() => {
    if (!Array.isArray(industryListData)) return [];

    return industryListData.map((item) => ({
      label: item?.name,
      value: item?.name,
    }));
  }, [industryListData]);

  const handleCancel = async (e) => {
    await dispatch(setUnsavedChanges(false));
    navigate(-1);
  };

  const onCancelClicked = async (e) => {
    if (hasChanged) {
      setCOnfirmModel2(true);
      await dispatch(setUnsavedChanges(false));
    } else {
      navigate(-1);
    }
  };

  const handleCancel2 = (e) => {
    setCOnfirmModel2(false);
  };

  const handelCancel = () => {
    setCOnfirmModel(false);
  };

  const handleClick = () => {
    setCOnfirmModel(true);
    const val = selectedTab === 1 ? " Profile " : " Company ";
    const message = "Are you sure you want to update your" + val + "details?";

    setCOnfirmMessage(message);
  };

  const showErrorMessage = (message) => {
    setErrorMessage(message ?? "Something went Wrong!");
    setErrorModel(true);
    setTimeout(() => {
      setErrorModel(false);
    }, 1500);
  };

  const validateImageFile = (file) => {
    if (file) {
      if (file.type.startsWith("image/")) {
        return true;
      } else {
        showErrorMessage("Only image files are allowed.");
        return false;
      }
    } else {
      showErrorMessage("Please select a file.");
      return false;
    }
  };

  const handleChangeCompanyLogo = async (event) => {
    const file = event?.target?.files[0]; // Get the single file selected
    const isValid = validateImageFile(file);
    if (!isValid) {
      return;
    }
    setCompanyLogo(URL.createObjectURL(file));
    let formData2 = new FormData();
    formData2.append("file", file); // Append image to FormData
    const result = await dispatch(
      uploadCompanyLogo({ id: userData?.customer?.id, body: formData2 })
    );
    if (
      uploadCompanyLogo.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setSuccessMessage("Company Logo Uploaded Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
      }, 1500);
    } else {
      setIsLoading(false);
      setErrorMessage(
        result?.payload?.error?.message
          ? result?.payload?.error?.message
          : "Something went Wrong!"
      );
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  const handleUpdateSendEmailStatus = async (e) => {
    const { checked } = e?.target;
    const body = {
      isDefaultEmail: checked,
      email: companyFormData.email,
      id: userData?.customer?.id,
    };
    setIsLoading(true);
    const result = await dispatch(UpdateCustomer(body));
    try {
      setIsLoading(false);
      if (
        UpdateCustomer.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        setIsLoading(false);
        setIsDefaultEmail(checked);
        setSuccessMessage(
          `Sending emails to contacts using the company email has been successfully ${
            checked ? "enabled" : "disabled"
          }!`
        );
        setSuccessModel(true);
        setTimeout(() => {
          setSuccessModel(false);
        }, 1500);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    setCOnfirmModel(false);
    await dispatch(setUnsavedChanges(false));
    if (selectedTab === 1) {
      let formData2 = new FormData();
      const body = {
        ...formData,
        phoneNumber: formData.phoneNumber.replace(/\D/g, ""),
        userId: userData.id,
      };
      formData2.append("file", image); // Append image to FormData
      formData2.append("body", JSON.stringify({ ...body }));
      const result = await dispatch(
        updateUser({ id: body?.userId, formData: formData2 })
      );
      if (
        updateUser.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        setIsLoading(false);
        setSuccessMessage("Profile Updated Successfully!");
        setSuccessModel(true);
        setTimeout(() => {
          setSuccessModel(false);
          getUserProfile().finally(() => navigate(-1));
        }, 1500);
      } else {
        //TODO: error popup here
        setIsLoading(false);
        setErrorMessage(
          result?.payload?.error?.message
            ? result?.payload?.error?.message
            : "Something went Wrong!"
        );
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    } else {
      const body = {
        ...companyFormData,
        phoneNumber: companyFormData.phoneNumber.replace(/\D/g, ""),
        id: userData.customer.id,
      };
      const result = await dispatch(UpdateCustomer(body));
      if (
        UpdateCustomer.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        setIsLoading(false);
        setSuccessMessage("Company Updated Successfully!");
        setSuccessModel(true);
        setTimeout(() => {
          let userData2 = JSON.parse(localStorage.getItem("userData"));
          userData2.customer.companyName = companyFormData.companyName;
          userData2.customer.countryCallingCode =
            companyFormData.countryCallingCode;
          userData2.customer.phoneNumber = companyFormData.phoneNumber;
          localStorage.setItem("userData", JSON.stringify(userData2));
          dispatch(saveCurrentUserData(userData2));
          setSuccessModel(false);
          navigate(-1);
        }, 1500);
      } else {
        //TODO: error popup here
        setIsLoading(false);
        setErrorMessage(
          result?.payload?.error?.message
            ? result?.payload?.error?.message
            : "Something went Wrong!"
        );
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    }
  };
  return (
    <div className="page__body">
      {isLoading ? <Loader /> : ""}
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {confirmModel ? (
        <ConfirmModel
          onAccept={handleSubmit}
          yes={"Yes"}
          no={"No"}
          onReject={handelCancel}
          title="Update Profile!"
          message={confirmMessage}
        />
      ) : (
        ""
      )}
      {confirmModel2 ? (
        <ConfirmModel
          onAccept={handleCancel}
          yes={"Yes"}
          no={"No"}
          onReject={handleCancel2}
          title="Update Profile!"
          message="You have unsaved changes. Are you sure you want to cancel? All changes will be discarded."
        />
      ) : (
        ""
      )}

      <div className="tabsWrap">
        <ul className="tabs">
          <li
            className={
              selectedTab === 1
                ? "tabs__link tabs__link--selected"
                : "tabs__link"
            }
            onClick={() => {
              setSelectedTab(1);
            }}
          >
            Account Information
          </li>
          {userData.role.name === "company" ? (
            <li
              className={
                selectedTab === 2
                  ? "tabs__link tabs__link--selected"
                  : "tabs__link"
              }
              onClick={() => {
                setSelectedTab(2);
              }}
            >
              Company Profile
            </li>
          ) : (
            ""
          )}
          <li
            className={
              selectedTab === 3
                ? "tabs__link tabs__link--selected"
                : "tabs__link"
            }
            onClick={() => {
              setSelectedTab(3);
            }}
          >
            Change Password
          </li>
          {userData.role.name === "company" ? (
            <li
              className={
                selectedTab === 4
                  ? "tabs__link tabs__link--selected"
                  : "tabs__link"
              }
              onClick={() => {
                setSelectedTab(4);
                dispatch(setUnsavedChanges(false));
              }}
            >
              Transaction History
            </li>
          ) : (
            ""
          )}
          {userData.role.name === "company" ? (
            <li
              className={
                selectedTab === 6
                  ? "tabs__link tabs__link--selected"
                  : "tabs__link"
              }
              onClick={() => {
                setSelectedTab(6);
                dispatch(setUnsavedChanges(false));
              }}
            >
              Payment Methods
            </li>
          ) : (
            ""
          )}
          {userData?.role?.name === "company" &&
          userPlanFeatures?.API_DOCUMENTATION ? (
            <li
              className={
                selectedTab === 5
                  ? "tabs__link tabs__link--selected"
                  : "tabs__link"
              }
              onClick={() => {
                setSelectedTab(5);
                dispatch(setUnsavedChanges(false));
              }}
            >
              API Key & Password
            </li>
          ) : (
            ""
          )}
        </ul>
      </div>
      <div className="tabsContent">
        {selectedTab === 1 ? (
          <div className="details">
            <div className="form">
              <section className="form__section">
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field form__Field--profileBox">
                      <label
                        className="form__uploadProfile"
                        for="uploadProfile"
                      >
                        <img
                          className="form__uploadProfile__picture"
                          src={imageData ? imageData : imageIcon}
                          alt=""
                        />
                        <span className="form__uploadProfile__edit">
                          <span className="icon">
                            <svg
                              width="11"
                              height="11"
                              viewBox="0 0 11 11"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.875 1.3797C7.99538 1.25932 8.13829 1.16383 8.29557 1.09868C8.45285 1.03353 8.62143 1 8.79167 1C8.96191 1 9.13048 1.03353 9.28776 1.09868C9.44505 1.16383 9.58796 1.25932 9.70833 1.3797C9.82871 1.50007 9.9242 1.64298 9.98935 1.80027C10.0545 1.95755 10.088 2.12612 10.088 2.29636C10.088 2.4666 10.0545 2.63518 9.98935 2.79246C9.9242 2.94974 9.82871 3.09265 9.70833 3.21303L3.52083 9.40053L1 10.088L1.6875 7.5672L7.875 1.3797Z"
                                stroke="white"
                                stroke-width="1.3"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                        </span>
                      </label>
                      <input
                        type="file"
                        id="uploadProfile"
                        className="form__uploadfiled"
                        onChange={handleChangeImage}
                        accept="image/*"
                      />
                      <div className="profileInfo">
                        <h3 className="profileInfo__name">
                          {formData.firstName} {formData.lastName}
                        </h3>
                        <p className="para">{formData.email}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="formRow formRow__2">
                  <div className="formCol">
                    <div className="form__Field">
                      <label for="name" className="form__label">
                        First Name<span style={{ color: "red" }}> * </span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        className="form__input form__input--sm"
                        placeholder="First Name"
                      />
                    </div>
                    <div className="form__error">
                      {formError.firstNameError}
                    </div>
                  </div>
                  <div className="formCol">
                    <div className="form__Field">
                      <label for="name" className="form__label">
                        Last Name<span style={{ color: "red" }}> * </span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        className="form__input form__input--sm"
                        placeholder="Last Name"
                      />
                    </div>
                    <div className="form__error">{formError.lastNameError}</div>
                  </div>
                </div>
                <div className="formRow formRow__2">
                  <div className="formCol">
                    <div className="form__Field">
                      <label for="email" className="form__label">
                        Email Address<span style={{ color: "red" }}> * </span>
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        maxLength={100}
                        value={formData.email}
                        disabled
                        className="form__input form__input--sm form__input--disabled"
                        placeholder="Email Address"
                      />
                    </div>
                  </div>
                  <div className="formCol">
                    <div className="form__Field">
                      <label for="phonenumber" className="form__label">
                        Phone Number
                        {userData.role.name === "company" ? (
                          <span style={{ color: "red" }}> * </span>
                        ) : null}
                      </label>
                      <CountryPhoneInput
                        countryCodeFieldName="countryCallingCode"
                        phoneFieldName="phoneNumber"
                        countryCode={formData.countryCallingCode}
                        phoneNumber={formData.phoneNumber}
                        onCountryChange={handleCountryCodeChange}
                        onPhoneChange={handlePhoneChange}
                      />
                      <div className="form__error"> {formError.phoneError}</div>
                    </div>
                  </div>
                  {userData?.role?.name === "company" &&
                  userPlanFeatures?.TWO_FACTOR_AUTHENTICATION ? (
                    <div className="formCol formCol--flex">
                      <div className="form__switchBtn">
                        <div className="form__switchBtn__option">
                          <label for="phonenumber" className="form__label">
                            Activate MFA
                          </label>
                          <div className="switchBtn">
                            <input
                              type="checkbox"
                              className="toggle"
                              id="toggle-mfa"
                              checked={formData?.isMfaEnabled}
                              onChange={(e) => {
                                handleChangeMfa(e.target.checked);
                              }}
                            />
                            <label for="toggle-mfa">
                              <span className="on">ON</span>
                              <span className="off">OFF</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {/* <div className="formCol">
                <div className="form__Field">
                  <label for="role" className="form__label">
                    Role
                  </label>
                  <input
                    type="role"
                    id="role"
                    name="role"
                    value={formData.role}
                    disabled
                    className="form__input form__input--sm  form__input--disabled"
                    placeholder="Email Address"
                  />
                  
                </div>
              </div> */}
                </div>
                <div className="btn__group">
                  <button
                    className="btn btn__white"
                    onClick={onCancelClicked}
                    type="button"
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn__primary"
                    onClick={handleClick}
                    disabled={
                      !hasChanged ||
                      formData.firstName === "" ||
                      formError.firstNameError != "" ||
                      formData.lastName === "" ||
                      formError.lastNameError != "" ||
                      (formData.phoneNumber === "" &&
                        userData.role.name == "company") ||
                      formError.phoneError != ""
                    }
                    type="submit"
                  >
                    Update
                  </button>
                </div>
              </section>
            </div>
          </div>
        ) : selectedTab === 2 ? (
          <div className="details">
            <div className="form">
              <section className="form__section">
                <div className="formRow">
                  <div className="formCol">
                    <div className="form__Field form__Field--profileBox">
                      <label
                        className="form__uploadProfile"
                        for="uploadProfile"
                      >
                        <img
                          className="form__uploadProfile__picture"
                          src={companyLogo ?? imageIcon}
                          alt=""
                        />
                        <span className="form__uploadProfile__edit">
                          <span className="icon">
                            <svg
                              width="11"
                              height="11"
                              viewBox="0 0 11 11"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.875 1.3797C7.99538 1.25932 8.13829 1.16383 8.29557 1.09868C8.45285 1.03353 8.62143 1 8.79167 1C8.96191 1 9.13048 1.03353 9.28776 1.09868C9.44505 1.16383 9.58796 1.25932 9.70833 1.3797C9.82871 1.50007 9.9242 1.64298 9.98935 1.80027C10.0545 1.95755 10.088 2.12612 10.088 2.29636C10.088 2.4666 10.0545 2.63518 9.98935 2.79246C9.9242 2.94974 9.82871 3.09265 9.70833 3.21303L3.52083 9.40053L1 10.088L1.6875 7.5672L7.875 1.3797Z"
                                stroke="white"
                                stroke-width="1.3"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                        </span>
                      </label>
                      <input
                        type="file"
                        id="uploadProfile"
                        className="form__uploadfiled"
                        accept="image/*"
                        onChange={handleChangeCompanyLogo}
                      />
                      <div className="profileInfo">
                        <h3 className="profileInfo__name">
                          {companyFormData.companyName}
                        </h3>
                        <p className="para">{companyFormData.email}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="formRow formRow__2">
                  <div className="formCol">
                    <div className="form__Field">
                      <label for="name" className="form__label">
                        Company Name<span style={{ color: "red" }}> * </span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="companyName"
                        value={companyFormData.companyName}
                        onChange={handleCompanyChange}
                        className="form__input form__input--sm"
                        placeholder="Company"
                      />
                    </div>
                    <div className="form__error">
                      {companyFormError.firstNameError}
                    </div>
                  </div>
                  <div className="formCol">
                    <div className="form__Field">
                      <label for="email" className="form__label">
                        Email Address
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        maxLength={100}
                        value={companyFormData.email}
                        className="form__input form__input--sm"
                        placeholder="Email Address"
                        onChange={handleCompanyChange}
                      />
                      <div className="form__error">
                        {companyFormError.emailError}
                      </div>
                    </div>
                    {userPlanFeatures?.EMAIL ? (
                      <p className="para para--right">
                        <div className="form__checkbox__option m_0">
                          <input
                            type="checkbox"
                            id="isDefaultEmail"
                            className="form__checkbox__input"
                            value={isDefaultEmail}
                            name="isDefaultEmail"
                            checked={isDefaultEmail ?? false}
                            disabled={companyFormError?.emailError}
                            onChange={handleUpdateSendEmailStatus}
                          />
                          <label
                            for="isDefaultEmail"
                            className="form__checkbox__label"
                          >
                            Allow to send Emails to Contacts
                          </label>
                        </div>
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="formRow formRow__2">
                  <div className="formCol">
                    <div className="form__Field">
                      <label for="phonenumber" className="form__label">
                        Phone Number
                      </label>
                      <CountryPhoneInput
                        countryCodeFieldName="countryCallingCode"
                        phoneFieldName="phoneNumber"
                        countryCode={companyFormData.countryCallingCode}
                        phoneNumber={companyFormData.phoneNumber}
                        onCountryChange={handleCompanyCountryCodeChange}
                        onPhoneChange={handleCompanyPhoneChange}
                      />
                      <div className="form__error">
                        {" "}
                        {companyFormError.phoneError}
                      </div>
                    </div>
                  </div>
                  {/* <div className="formCol">
              <div className="form__Field">
                <label for="role" className="form__label">
                  Role
                </label>
                <input
                  type="role"
                  id="role"
                  name="role"
                  value={formData.role}
                  disabled
                  className="form__input form__input--sm  form__input--disabled"
                  placeholder="Email Address"
                />
                
              </div>
            </div> */}
                  <div className="form__group">
                    <label for="industryType" className="form__label">
                      Industry <span style={{ color: "red" }}> * </span>
                    </label>
                    <Dropdown
                      id="industryType"
                      name="industryType"
                      options={formattedIndustryList}
                      placeholder="-Select-"
                      creatable
                      selectedValue={companyFormData.industryType}
                      onChange={handleChangeIndustryType}
                    />
                    <div className="form__error">
                      {companyFormError?.industryTypeError}
                    </div>
                  </div>
                </div>
                <div className="btn__group">
                  <button
                    className="btn btn__white"
                    onClick={onCancelClicked}
                    type="button"
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn__primary"
                    onClick={handleClick}
                    disabled={
                      !hasChanged ||
                      companyFormData.companyName === "" ||
                      companyFormError.firstNameError != "" ||
                      companyFormData.phoneNumber === "" ||
                      companyFormError.phoneError != "" ||
                      companyFormError.emailError != ""
                    }
                    type="submit"
                  >
                    Update
                  </button>
                </div>
              </section>
            </div>
          </div>
        ) : selectedTab === 3 ? (
          <ChangePassword />
        ) : selectedTab === 4 ? (
          <TransactionHistory
            stripeCustomerId={userData?.customer?.stripeCustomerId}
          />
        ) : selectedTab === 6 ? (
          <PaymentMethod />
        ) : (
          ""
        )}
        <CustomerApiKeyPassword
          key={`profile-${userData?.customer?.id}`}
          visible={selectedTab === 5}
          customerId={userData?.customer?.id}
          apiKeyAndPassword={apiKeyAndPassword}
          customerEmail={userData ? userData?.email : ""}
        />
      </div>
    </div>
  );
};
